import * as React from "react";
import { FunnelContainer } from "ui/funnelContainer/FunnelContainer";
import {
  MenuItem,
  Typography,
  makeStyles,
  useMediaQuery,
  useTheme,
  Box,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
} from "@material-ui/core";
import CheckCircleIcon from "components/collectFunnel/assets/turquoiseCheck.svg";
import InfoIcon from "components/collectFunnel/assets/infoIcon.svg";
import AddIcon from "components/collectFunnel/assets/pinkAddIcon.svg";
import Underline from "components/collectFunnel/assets/yellowUnderline.svg";
import { FunnelCardContainer } from "ui/funnelCardContainer/FunnelCardContainer";
import { RoundedSelect } from "ui/roundedSelect/RoundedSelect";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { Grid } from "ui/grid/Grid";
import { FREEZER_NAME_TAG } from "components/collectFunnel/constants";
import Place from "components/collectFunnel/assets/place.svg";
import ClearIcon from "@material-ui/icons/Clear";
import useCart from "hooks/useCart";

export const CollectProductSelector = ({
  handleNextStep,
  handlePreviousStep,
  noZone,
  handleSelect,
  deleteProduct,
  productsToCollect,
  addProduct,
  noDetail,
  noNavigation,
  error,
  productTypes,
  isCollectFunnel,
}) => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down("sm"));
  const [cart] = useCart();

  const classes = useStyles();
  const [multiCollect, setMultiCollect] = React.useState(
    isCollectFunnel ? true : productsToCollect?.length < cart.selection?.length
  );

  React.useEffect(() => {
    if (!isCollectFunnel) {
      setMultiCollect(productsToCollect?.length < cart.selection?.length);
    }
  }, [productsToCollect, isCollectFunnel, cart.selection?.length]);
  const navigationButtons = (
    <Grid container item justify="space-between">
      <Grid item>
        <Button startIcon={<ArrowBackIcon />} color="secondary" onClick={handlePreviousStep}>
          Retour
        </Button>
      </Grid>
      <Grid item>
        <Button
          disabled={(productsToCollect && productsToCollect[0]?.type === "not a product") || noZone}
          variant="contained"
          color="primary"
          onClick={handleNextStep}
        >
          Continuer
        </Button>
      </Grid>
    </Grid>
  );

  if (noZone) {
    return (
      <FunnelContainer>
        <Box className={classes.info}>
          <Grid container spacing={5}>
            <Grid item xs={12} md={3}>
              <Place />
            </Grid>
            <Grid item xs={12} md={8}>
              <Box mb={3}>
                <Typography color="secondary" variant="h2">
                  Nous ne collectons pas encore ici !
                </Typography>
              </Box>
              <Box className={classes.box}>
                <Typography color="secondary" variant="body1">
                  On souhaite rendre la collecte accessible à tous alors on y travaille !
                </Typography>
              </Box>
            </Grid>
            {navigationButtons}
          </Grid>
        </Box>
      </FunnelContainer>
    );
  }

  const collectProductsParagraph = (
    <Grid item xs={12} md={4}>
      <div className={classes.listTitle}>Nous récupérons :</div>
      <List dense>
        {productTypes?.map((productType) => {
          return (
            <ListItem key={productType.id} disableGutters>
              <ListItemIcon className={classes.circle}>
                <CheckCircleIcon />
              </ListItemIcon>

              <ListItemText primary={`${productType.name}`} />
            </ListItem>
          );
        })}
      </List>
      <div className={classes.roundedInformation}>
        <InfoIcon />
        <div>Vous pouvez ajouter autant d’appareils que vous le souhaitez</div>
      </div>
    </Grid>
  );
  return (
    <FunnelContainer>
      <div className={classes.container}>
        <Grid container={!noDetail}>
          <div className={!noDetail && classes.leftBox}>
            <FunnelCardContainer className={classes.cardContainer}>
              <Box mb={isTablet ? 2 : 5}>
                <Typography color="secondary" variant={isTablet ? "h3" : "h2"}>
                  Indiquez le type d’appareil à récupérer
                </Typography>
              </Box>
              {productsToCollect?.map((product, index) => (
                <div key={product?.id || 0}>
                  <Box mb={1} display="flex">
                    {index > 0 && (
                      <IconButton onClick={() => deleteProduct(index)} className={classes.iconButton}>
                        <ClearIcon className={classes.clearIcon} />
                      </IconButton>
                    )}
                    <RoundedSelect
                      id={index}
                      className={classes.select}
                      fullWidth
                      placeholder="Choisissez l'appareil"
                      value={product?.id || 0}
                      onChange={(event) => handleSelect(event.target.value, index)}
                    >
                      {productTypes?.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </RoundedSelect>
                  </Box>
                </div>
              ))}
              {productsToCollect?.find((product) => product.type === FREEZER_NAME_TAG) && (
                <Box color={"red"}>
                  <Typography variant="body2">
                    Nous ne récupérons pas les réfrigérateurs américains et les congélateurs coffre.
                  </Typography>
                </Box>
              )}

              {productsToCollect?.length > 0 &&
                multiCollect &&
                productsToCollect[productsToCollect.length - 1]?.id !== 0 && (
                  <Box display="flex" mt={2} onClick={addProduct}>
                    <AddIcon />
                    <Box pl={2} display="grid" justifyItems="right" pt="4px">
                      <Typography color="secondary" variant="body1">
                        Ajouter un appareil
                      </Typography>
                      <Underline />
                    </Box>
                  </Box>
                )}
              {error && (
                <Box mt={1} color={"red"}>
                  <Typography variant="body2">{error}</Typography>
                </Box>
              )}
            </FunnelCardContainer>
            {!noNavigation && navigationButtons}
          </div>

          {!noDetail && collectProductsParagraph}
        </Grid>
      </div>
    </FunnelContainer>
  );
};

const useStyles = makeStyles((theme) => ({
  container: {
    position: "relative",
  },
  cardContainer: {
    padding: theme.spacing(5),
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(3),
    },
  },
  leftBox: {
    width: "60%",
    marginRight: theme.spacing(8),
    [theme.breakpoints.down("sm")]: {
      marginRight: 0,
      width: "100%",
    },
  },
  select: {
    height: theme.spacing(7),
    background: "white",
    border: "1px solid rgba(219, 223, 232, 0.6)",
    boxSizing: "border-box",
    borderRadius: 12,
  },
  roundedInformation: {
    border: "1px solid #D7D7D7",
    boxSizing: "border-box",
    borderRadius: theme.spacing(3),
    display: "grid",
    gridAutoFlow: "column",
    gridColumnGap: theme.spacing(2),
    padding: theme.spacing(3),
    marginTop: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(1),
    },
  },
  circle: {
    minWidth: theme.spacing(5),
  },
  listTitle: {
    fontWeight: "bold",
    fontSize: 16,
    lineHeight: "120%",
    textTransform: "uppercase",
    color: theme.palette.secondary.dark,
    paddingTop: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(2),
    },
  },
  info: {
    marginTop: theme.spacing(5),
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(0),
      textAlign: "center",
    },
  },
  iconButton: {
    marginLeft: -theme.spacing(4),
    padding: theme.spacing(0.5),
    [theme.breakpoints.down("sm")]: {
      marginLeft: -theme.spacing(2.5),
      padding: theme.spacing(0),
    },
  },
  clearIcon: {
    [theme.breakpoints.down("sm")]: {
      width: theme.spacing(2.5),
    },
  },
}));
